// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TooltipContent__tooltip-dd69ce {
  background-color: var(--addition-110);
  border-radius: 8px;
  color: var(--addition-50);
  font: var(--font-caption-4);
  letter-spacing: var(--font-spacing-caption-4);
  padding: 4px 8px;
}

.TooltipContent__tooltip-dd69ce:has(.TooltipContent__content-d55070:empty) {
  display: none;
}

.TooltipContent__tooltip-dd69ce[data-placement^=top] .TooltipContent__arrow-b66759 {
  bottom: 1px;
}

.TooltipContent__tooltip-dd69ce[data-placement^=bottom] .TooltipContent__arrow-b66759 {
  top: 0;
}

.TooltipContent__tooltip-dd69ce[data-placement^=left] .TooltipContent__arrow-b66759 {
  inset-inline-end: 1px;
}

.TooltipContent__tooltip-dd69ce[data-placement^=right] .TooltipContent__arrow-b66759 {
  left: -5px;
}

.TooltipContent__arrow-b66759::after {
  content: "";
  position: absolute;
  z-index: -1;
  height: 0;
  width: 0;
  transform: translateX(-50%);
  top: 100%;
  left: 50%;
}

.TooltipContent__tooltip-dd69ce[data-placement^=top] .TooltipContent__arrow-b66759::after {
  border-right: solid 8px transparent;
  border-left: solid 8px transparent;
  border-top: solid 6px var(--addition-110);
}

.TooltipContent__tooltip-dd69ce[data-placement^=bottom] .TooltipContent__arrow-b66759::after {
  border-right: solid 8px transparent;
  border-left: solid 8px transparent;
  border-bottom: solid 6px var(--addition-110);
  top: -6px;
}

.TooltipContent__tooltip-dd69ce[data-placement^=left] .TooltipContent__arrow-b66759::after {
  border-top: solid 6px transparent;
  border-bottom: solid 6px transparent;
  border-left: solid 6px var(--addition-110);
  transform: translateY(-50%);
}

.TooltipContent__tooltip-dd69ce[data-placement^=right] .TooltipContent__arrow-b66759::after {
  border-top: solid 6px transparent;
  border-bottom: solid 6px transparent;
  border-right: solid 6px var(--addition-110);
  transform: translateY(-50%);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Tooltip/TooltipContent/TooltipContent.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qCAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,6CAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,MAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,SAAA;AACF;;AAEA;EACE,mCAAA;EACA,kCAAA;EACA,yCAAA;AACF;;AAEA;EACE,mCAAA;EACA,kCAAA;EACA,4CAAA;EACA,SAAA;AACF;;AAEA;EACE,iCAAA;EACA,oCAAA;EACA,0CAAA;EACA,2BAAA;AACF;;AAEA;EACE,iCAAA;EACA,oCAAA;EACA,2CAAA;EACA,2BAAA;AACF","sourcesContent":[".tooltip {\n  background-color: var(--addition-110);\n  border-radius: 8px;\n  color: var(--addition-50);\n  font: var(--font-caption-4);\n  letter-spacing: var(--font-spacing-caption-4);\n  padding: 4px 8px;\n}\n\n.tooltip:has(.content:empty) {\n  display: none;\n}\n\n.tooltip[data-placement^='top'] .arrow {\n  bottom: 1px;\n}\n\n.tooltip[data-placement^='bottom'] .arrow {\n  top: 0;\n}\n\n.tooltip[data-placement^='left'] .arrow {\n  inset-inline-end: 1px;\n}\n\n.tooltip[data-placement^='right'] .arrow {\n  left: -5px;\n}\n\n.arrow::after {\n  content: '';\n  position: absolute;\n  z-index: -1;\n  height: 0;\n  width: 0;\n  transform: translateX(-50%);\n  top: 100%;\n  left: 50%;\n}\n\n.tooltip[data-placement^='top'] .arrow::after {\n  border-right: solid 8px transparent;\n  border-left: solid 8px transparent;\n  border-top: solid 6px var(--addition-110);\n}\n\n.tooltip[data-placement^='bottom'] .arrow::after {\n  border-right: solid 8px transparent;\n  border-left: solid 8px transparent;\n  border-bottom: solid 6px var(--addition-110);\n  top: -6px;\n}\n\n.tooltip[data-placement^='left'] .arrow::after {\n  border-top: solid 6px transparent;\n  border-bottom: solid 6px transparent;\n  border-left: solid 6px var(--addition-110);\n  transform: translateY(-50%);\n}\n\n.tooltip[data-placement^='right'] .arrow::after {\n  border-top: solid 6px transparent;\n  border-bottom: solid 6px transparent;\n  border-right: solid 6px var(--addition-110);\n  transform: translateY(-50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `TooltipContent__tooltip-dd69ce`,
	"content": `TooltipContent__content-d55070`,
	"arrow": `TooltipContent__arrow-b66759`
};
module.exports = ___CSS_LOADER_EXPORT___;
